import script from "./GetCoundownInBahasa.vue?vue&type=script&setup=true&lang=js"
export * from "./GetCoundownInBahasa.vue?vue&type=script&setup=true&lang=js"

import "./GetCoundownInBahasa.vue?vue&type=style&index=0&id=235bc066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-235bc066"]])

export default __exports__